import React, { useState, useEffect } from 'react';
import { axiosInstance } from "../../constants/axiosInstance";
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const FAQPage = () => {
  const [loading, setLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    getFAQS();
  }, []);

  const getFAQS = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/api/v1/faq/getfaqs');
      const aboutUs = res.data.data;
      if (aboutUs.length !== 0) {
        setFaqs(aboutUs[0].faqs);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full bg-no-repeat bg-center bg-cover flex items-center justify-center">
        <img src={faqs} className="object-contain max-h-64" alt="FAQ Header" />
      </div>
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-center mb-12 text-gray-900">
          Frequently Asked Questions
        </h1>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-white rounded-lg shadow-lg overflow-hidden"
        >
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Question</th>
                <th className="w-24 px-6 py-4"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {faqs.map((faq, index) => (
                <React.Fragment key={index}>
                  <tr 
                    className={`hover:bg-gray-50 cursor-pointer transition-colors ${
                      expandedIndex === index ? 'bg-gray-50' : ''
                    }`}
                    onClick={() => toggleExpand(index)}
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <span className="h-8 w-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3">
                          Q
                        </span>
                        <span className="text-gray-900 font-medium">
                          {faq.Question}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <motion.div
                        animate={{ rotate: expandedIndex === index ? 180 : 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <ChevronDown className="w-5 h-5 text-gray-500" />
                      </motion.div>
                    </td>
                  </tr>
                  <AnimatePresence>
                    {expandedIndex === index && (
                      <motion.tr
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <td colSpan="2" className="px-6 py-4 bg-gray-50">
                          <div className="flex">
                            <span className="h-8 w-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center mr-3 flex-shrink-0">
                              A
                            </span>
                            <div className="text-gray-600 whitespace-pre-wrap">
                              {faq.Answer}
                            </div>
                          </div>
                        </td>
                      </motion.tr>
                    )}
                  </AnimatePresence>
                </React.Fragment>
              ))}
            </tbody>
          </table>
          
          {faqs.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              No FAQs available
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};